/**
 * Cognito build config.
 *
 * The analytics app signs in through the AWS Cognito hosted UI
 * (Authorization Code + PKCE). The COGNITO_* keys come from the environment's
 * helm values file.
 *
 * config/env.js feeds these into webpack DefinePlugin by replacing the whole
 * `process.env` object, so a key that is not in the values file is simply
 * undefined and needs no typeof guard.
 */

const read = (value) => (value && value !== 'undefined' ? value : null)

export const cognitoConfig = {
  domain: read(process.env.COGNITO_DOMAIN),
  clientId: read(process.env.COGNITO_CLIENT_ID),
  redirectUri: read(process.env.COGNITO_REDIRECT_URI),
  logoutUri: read(process.env.COGNITO_LOGOUT_URI),
  scope: read(process.env.COGNITO_SCOPE) || 'openid email profile'
}

// Fail loudly when the Cognito build config is missing. Without it, beginLogin
// would send the browser to `https://null/oauth2/authorize?...client_id=null` —
// an opaque DNS dead end — while the build, boot and /healthz all stay green.
// This is deliberately NOT called at module load: App.js imports the auth chain
// unconditionally, including the Care-embedded path where the host owns auth and
// these globals are legitimately absent, so a load-time throw would break a
// correctly-configured embed. Call it on the standalone login path only.
export const assertCognitoConfigured = () => {
  const missing = [ 'domain', 'clientId', 'redirectUri' ].filter((key) => !cognitoConfig[key])
  if (missing.length) {
    throw new Error(
      `Cognito is not configured: missing ${missing.join(', ')}. ` +
      'Set the matching COGNITO_* build variables for this deployment.'
    )
  }
}
